import { PureComponent, ReactNode } from 'react';
import Fuse from 'fuse.js';
import { DoctorReferralIcon } from '../rightPanel/workspace/padV2/RowIcons';
import DoctorReferralTable from '../rightPanel/workspace/padV2/DoctorReferralTable';
import DoctorReferralSearchInput, { GReferWithTrack } from './DoctorReferralSearchInput';
import { connect } from 'react-redux';
import { updateReferal } from '../../../store/actions/prescriptionPad';
import { toCreateReferalData } from '../../common/ReferalDialog';
import { getPrescription } from '../../../store/selectors/prescriptionPad';
import { GlobalState } from '../../../store/reducers';
import { Prescription } from '../../../store/types/prescription';
import fetchSpecialityForDoctor, { Res } from '../../../api/fetchSpecialityForDoctor';
import { ThunkDispatch } from 'redux-thunk';
import { Actions } from '../../../store/actions';
import { generateSpecialityId } from '../../../store/utils';
import { getGArray, getItemFromMisc, updateG } from '../../../store/idbHandler';
import { ReferralConfig } from '../../../api/fetchMyGenie';
import { getMActiveId, getReferralSetup, setReferralSetup } from '../../../store/localstorage';
import { DB_TABLES } from '../../../store/dbTables';
import AntButton from '../rightPanel/workspace/padV2/AntButton';
import fetchDoctorsInMyBusiness from '../../../api/fetchDoctorsInMyBusiness';
import { GenieItem } from '../../../store/db';
import { downloadIcon, loaderIcon, refreshIcon } from '../../common/Icons';

type Item = {
    id: string;
    name: string;
    specilization: string;
};

const fuseConfig = {
    keys: ['name', 'specilization'],
    threshold: 0.2,
};

type Props = {
    px?: Prescription;
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    sectionName?: string;
};

type State = {
    specialityRes?: Res;
    withinBusiness?: boolean;
    isSetUpDone?: boolean;
    isSettingUp?: boolean;
    mobileOptional?: boolean;
};

class DoctorReferralCard extends PureComponent<Props, State> {
    fuse = new Fuse([] as Item[], fuseConfig);
    state: State = {
        specialityRes: undefined,
        withinBusiness: false,
        isSetUpDone: getReferralSetup(),
        mobileOptional: false,
    };

    onSave = async (referData: GReferWithTrack, index?: number) => {
        const { dispatch, px } = this.props;
        const { specialityRes } = this.state;

        const selectedSpeciality = specialityRes?.speciality?.find(
            (specialty) =>
                `${specialty.name?.toLowerCase()}` == referData.doc.s_name?.toLowerCase(),
        );

        if (!px) {
            return;
        }

        const oldRefers = px.refer?.doc || [];

        if (selectedSpeciality) {
            let newDocs = [...oldRefers];
            if (index === undefined) {
                newDocs = [
                    ...oldRefers,
                    {
                        s_name: referData.doc.s_name || selectedSpeciality.s_name,
                        s_id:
                            referData.doc.s_id ||
                            (selectedSpeciality.id.toString() || referData.doc.s_name
                                ? generateSpecialityId(referData.doc.s_name || '')
                                : undefined),

                        ...referData.doc,
                    },
                ];
            } else {
                newDocs[index] = {
                    s_name: referData.doc.s_name || selectedSpeciality.s_name,
                    s_id:
                        referData.doc.s_id ||
                        (selectedSpeciality.id.toString() || referData.doc.s_name
                            ? generateSpecialityId(referData.doc.s_name || '')
                            : undefined),

                    ...referData.doc,
                };
            }
            dispatch(
                updateReferal(
                    toCreateReferalData({
                        data: {
                            doc: newDocs,
                        },
                        ptId: px.patient.id || px.patient.localId,
                    }),
                ),
            );
        } else {
            let newDocs = [...oldRefers];
            if (index === undefined) {
                newDocs = [
                    ...oldRefers,
                    {
                        ...referData.doc,
                        s_name: referData.doc.s_name,
                        s_id:
                            referData.doc.s_id ||
                            (referData.doc.s_name
                                ? generateSpecialityId(referData.doc.s_name || '')
                                : undefined),
                    },
                ];
            } else {
                newDocs[index] = {
                    ...referData.doc,
                    s_name: referData.doc.s_name,
                    s_id:
                        referData.doc.s_id ||
                        (referData.doc.s_name
                            ? generateSpecialityId(referData.doc.s_name || '')
                            : undefined),
                };
            }

            dispatch(
                updateReferal(
                    toCreateReferalData({
                        data: {
                            doc: newDocs,
                        },
                        ptId: px.patient.id || px.patient.localId,
                    }),
                ),
            );
        }
    };

    onSaveNotes = (index: number, notes: string) => {
        const { dispatch, px } = this.props;

        if (!px) {
            return;
        }

        const refers = px.refer?.doc || [];
        refers[index].note = notes;

        dispatch(
            updateReferal({
                ...px.refer,
                doc: refers,
            }),
        );
    };

    onMount = async () => {
        const config = await getItemFromMisc<ReferralConfig>(
            getMActiveId() || '',
            'referralConfig',
        );

        this.setState({
            withinBusiness: config.withinBusiness,
            mobileOptional: config.mobileOptional,
            isSetUpDone: !config.withinBusiness,
        });

        if (config.withinBusiness) {
            const allDoctors = await getGArray<{
                id: string;
                name?: { f: string; l: string };
                specilization: string;
                type?: 'doctor' | 'speciality';
                s_id: string;
            }>(getMActiveId() || '', DB_TABLES.doctorsInBiz);

            this.setState({ isSetUpDone: allDoctors?.length > 0 });
            setReferralSetup(allDoctors?.length > 0);

            const fuseData = allDoctors.map((t) => ({
                id: t.id,
                name: [t.name?.f, t.name?.l].filter(Boolean).join(' '),
                specilization: t.specilization,
                s_id: t.s_id,
                type: t.type,
            }));
            console.log(fuseData, 'fuseData');
            this.fuse = new Fuse(fuseData, fuseConfig);
            return;
        }

        fetchSpecialityForDoctor()
            .then((res) => {
                if (res.success) {
                    this.setState({ specialityRes: res });
                } else {
                    console.error('error');
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    async componentDidMount(): Promise<void> {
        this.onMount();
    }

    deleteReferral = (index: number) => {
        const { dispatch, px } = this.props;

        if (!px) {
            return;
        }

        const refers = px.refer?.doc || [];
        refers.splice(index, 1);

        dispatch(
            updateReferal({
                ...px.refer,
                doc: refers,
            }),
        );
    };

    setupReferral = async (): Promise<void> => {
        this.setState({ isSettingUp: true });
        const doctors = await fetchDoctorsInMyBusiness();
        await updateG(
            getMActiveId() || '',
            DB_TABLES.doctorsInBiz,
            // TODO: fake casting
            (doctors.data || []) as GenieItem[],
        );
        this.setState({ isSettingUp: false });
        this.onMount();
    };

    onSearch = (query: string): Item[] => {
        return this.fuse.search(query).map((item) => item.item);
    };

    render(): ReactNode {
        const { px, sectionName } = this.props;
        const {
            specialityRes,
            isSetUpDone,
            withinBusiness,
            isSettingUp,
            mobileOptional,
        } = this.state;

        return (
            <div className="rounded-8 pt-8 px-16 pb-16 bg-white row focusable">
                <div className="flex items-center space-x-16 justify-between w-full">
                    <div className="space-x-10 flex items-center">
                        <div>
                            <DoctorReferralIcon />
                        </div>
                        <p className="font-700 text-16 text-neutral-black">
                            {sectionName || 'Refer to a doctor'}
                        </p>
                    </div>
                    {isSetUpDone && withinBusiness && (
                        <div>
                            <button
                                className="secondary-btn px-8 py-4 body-2 space-x-8 font-400"
                                onClick={this.setupReferral}
                            >
                                <span className="whitespace-nowrap select-none">Refresh</span>
                                {isSettingUp
                                    ? loaderIcon('w-13 h-13 fill-actionPrimary animate-spin')
                                    : refreshIcon('w-13 h-13 fill-actionPrimary')}
                            </button>
                        </div>
                    )}
                </div>

                <DoctorReferralTable
                    referData={px?.refer}
                    deleteReferral={this.deleteReferral}
                    onSaveNotes={this.onSaveNotes}
                    onSelect={this.onSave}
                    specialities={specialityRes?.speciality}
                    mobileOptional={mobileOptional}
                />

                {withinBusiness && !isSetUpDone ? (
                    <div className="mt-8 ml-32">
                        <AntButton
                            type="secondary"
                            onClick={this.setupReferral}
                            isLoading={isSettingUp}
                            icon={downloadIcon('w-13 h-13 fill-darwin-accent-bright-blue-800')}
                        >
                            Setup referral
                        </AntButton>
                    </div>
                ) : (
                    px && (
                        <div className="mt-8 space-y-16 w-full">
                            <DoctorReferralSearchInput
                                elements={[]}
                                onSelect={this.onSave}
                                specialities={specialityRes?.speciality}
                                onSearch={withinBusiness ? this.onSearch : undefined}
                                mobileOptional={mobileOptional}
                                docid={px?.doctor._id}
                            />
                        </div>
                    )
                )}
            </div>
        );
    }
}

export default connect((state: GlobalState) => ({
    px: getPrescription(state),
}))(DoctorReferralCard);
